<template>
<div id="contenedor-agregar-nuevo-catalogo-expediente">
    <v-form ref="agregarNuevoCatalogoExpediente" v-model="esformularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar Documento de Catálogo Expediente
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-select
            v-model="expedienteDocumento.idTipoDocumento"
            label="Tipo de Documento"
            :items="getCatalogoTiposDocumentos"
            item-text="descripcion"
            item-value="id"
            :rules="[mixReglas.requerido]"
            required>
          </custom-select>
          <custom-text-area
          v-model="expedienteDocumento.descripcion"
          label="Descripción"
          :rules="[mixReglas.requerido]"
          required>
          </custom-text-area>
          <v-row>
          </v-row>
          <v-row align="center">
            <!-- <custom-select
              cols="3"
              v-model="expedienteDocumento.etapa"
              label="Estapa"
              :items="itemsEtapa"
              item-text="etapa"
              item-value="valor"
              :rules="[mixReglas.requerido]"
              required>
            </custom-select> -->
            <custom-text-field
              cols="3"
              v-model.number="expedienteDocumento.orden"
              type="number"
              label="Orden"
              :rules="[mixReglas.requerido]"
              required>
            </custom-text-field>
            <custom-text-field
            cols="3"
            v-model.number="expedienteDocumento.numeroDocumento"
            type="number"
            label="Numero de Documento">
            </custom-text-field>
            <v-switch
              cols="3"
              v-model="expedienteDocumento.seRepite"
              label="¿El documento se repite?"
              inset>
            </v-switch>
          </v-row>
          <v-card-title class="secondary--text">¿En que aplica este documento?</v-card-title>
          <v-row justify="start">
            <v-switch class="mx-4"
              cols="4"
              v-model="expedienteDocumento.esObra"
              label="Obra"
              inset>
            </v-switch>
            <v-switch class="mx-4"
              cols="4"
              v-model="expedienteDocumento.esServicio"
              label="Servicio"
              inset>
            </v-switch>
            <v-switch class="mx-4"
              cols="4"
              v-model="expedienteDocumento.esMinuta"
              label="Minuta"
              inset>
            </v-switch>
            <v-switch class="mx-4"
              cols="4"
              v-model="expedienteDocumento.esLaboratorio"
              label="Laboratorio"
              inset>
            </v-switch>
            <v-switch class="mx-4"
              cols="4"
              v-model="expedienteDocumento.esAutorizacionFp"
              label="Autorización FP"
              inset>
            </v-switch>
            <v-switch class="mx-4"
              cols="4"
              v-model="expedienteDocumento.esJustificacionExcedente"
              label="Justificación Excedente"
              inset>
            </v-switch>
            <v-switch class="mx-4"
              cols="4"
              v-model="expedienteDocumento.esNotaBitacora"
              label="Nota Bitacora"
              inset>
            </v-switch>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarCatalogoExpediente"
            :disabled="!esformularioValido || enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
</div>
</template>

<script>
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
// import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixCatalogoExpedientes from './mixCatalogoExpedientes';

export default {
  name: 'AgregarNuevoCatalogoExpediente',
  mixins: [mixCatalogoExpedientes],
  components: {
    CustomTextField,
    CustomSelect,
    CustomButton,
    CustomTextArea,
  },
  data() {
    return {
      esformularioValido: false,
      enviandoFormulario: false,
      // itemsEtapa: [
      //   { etapa: 'AE', valor: 1 },
      //   { etapa: 'EJ', valor: 2 },
      //   { etapa: 'FE', valor: 3 },
      // ],
      expedienteDocumento: {
        idTipoDocumento: '',
        seRepite: false,
        descripcion: '',
        // etapa: 1,
        orden: 0,
        numeroDocumento: 0,
        modulo: null,
        esObra: false,
        esServicio: false,
        esMinuta: false,
        esLaboratorio: false,
        esAutorizacionFp: false,
        esJustificacionExcedente: false,
        esNotaBitacora: false,
      },

    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.agregarNuevoCatalogoExpediente.reset();
    },
  },
};
</script>

<style>

</style>
